import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioSummaryCard = ({ title, value, change, changePercent, icon, trend }) => {
  const isPositive = change >= 0;
  const trendColor = isPositive ? 'text-success' : 'text-destructive';
  const bgColor = isPositive ? 'bg-success/10' : 'bg-destructive/10';

  return (
    <div className="card-elevated p-6 hover-financial">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-lg ${bgColor}`}>
            <Icon name={icon} size={20} className={trendColor} />
          </div>
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        <div className="flex items-center space-x-1">
          <Icon 
            name={isPositive ? "TrendingUp" : "TrendingDown"} 
            size={16} 
            className={trendColor} 
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <p className="text-2xl font-bold text-foreground font-mono">{value}</p>
        <div className="flex items-center space-x-2">
          <span className={`text-sm font-semibold ${trendColor}`}>
            {isPositive ? '+' : ''}{change}
          </span>
          <span className={`text-sm font-medium ${trendColor}`}>
            ({isPositive ? '+' : ''}{changePercent}%)
          </span>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSummaryCard;